import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setActivity } from '../../store/AppSlice';
import Brae1 from '../../img/brae/brae1.jpg'; 
import Brae2 from '../../img/brae/brae2.jpg'; 
import Brae3 from '../../img/brae/brae3.jpg'; 

const WalkBraeDetails = () => {

  const dispatch = useDispatch();

  const navigateToActivity = () => {
    dispatch(setActivity(""));
  }

  return (
    <div className="row">
    <div className="col-12 imagesBackgroundColour">
        <div className="generalTextBox">
          <p className="activity-back-button">
            <span className="navigate-span"><a className="navigate-button" onClick={navigateToActivity}>Back</a></span>
          </p>
        </div>
    </div>
    <div className="col-12 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <h2 className="walks-section-heading">The Brae</h2>
            <h3 className="walks-detail-heading"><strong>Directions</strong></h3>
            <p className="walk-text">Head out of the village back towards Glenelg and up the steep hill known locally as the Brae.
            </p>      
            <h3 className="walks-detail-heading"><strong>Time</strong></h3>
            <p className="walk-text">20 mins there and back unless you linger at the viewpoint enjoying the views.
            </p>                                           
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour">
      <img src={Brae1} alt="View of Arnisdale" className="gallery-image" />
    </div>
    <div className="col-12 col-md-6 imagesBackgroundColour">
      <img src={Brae3} alt="View of Arnisdale" className="gallery-image" />
    </div>
    <div className="col-12 imagesBackgroundColour">
      <div className="generalText">
          <div className="generalTextBox">
            <p className="activity-back-button">
              <span className="navigate-span"><a className="navigate-button" onClick={navigateToActivity}>Back</a></span>
            </p>
          </div>
      </div>
    </div>
    </div>
  );
}

export default WalkBraeDetails
